/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Delivery_TermInputs */

const en_reference_dataset_delivery_term = /** @type {(inputs: Reference_Dataset_Delivery_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery terms`)
};

/**
* | output |
* | --- |
* | "Delivery terms" |
*
* @param {Reference_Dataset_Delivery_TermInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_delivery_term = /** @type {((inputs?: Reference_Dataset_Delivery_TermInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Delivery_TermInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_delivery_term(inputs)
});